export const EXPERIMENT_COOKIE_NAME = "cro_web_169_variant";

export type ExperimentVariant = "control" | "redirect";

/**
 * Get the CRO-WEB-169 experiment variant from cookie
 * Returns null if no valid variant is found
 */
export const getCroWeb169VariantFromCookie = (): ExperimentVariant | null => {
  if (typeof window === "undefined") return null;

  const cookieValue = document.cookie
    .split("; ")
    .find((row) => row.startsWith(`${EXPERIMENT_COOKIE_NAME}=`))
    ?.split("=")[1];

  if (cookieValue === "control" || cookieValue === "redirect") {
    return cookieValue;
  }

  return null;
};
